<template>
  <footer class="footer-atom">
    <div class="footer-atom__content">
      <div class="footer-atom__content__links">
        <div class="footer-atom__content__right">
          <div class="footer-atom__logo">
            <a href="https://www.architectscan.se/" target="_blank">
              <img class="footer-atom__logo__acan" v-bind:src="acan" />
            </a>
          </div>

          <div class="footer-atom__links">
            <router-link to="/future">Minska utsläppen</router-link>
            <router-link to="/about">Om initiativet</router-link>
          </div>
        </div>
      </div>
      <div class="footer-atom__grid__copyright">
        <span>&copy;</span>
        <span>{{ ' ' + currentYear }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
      acan: require('@/assets/logotypes/acan-white.svg'),
    };
  },
};
</script>

<style scoped>
.footer-atom {
  background-color: black;
}
.footer-atom__content {
  padding: 20px;
}

.footer-atom__logo__acan {
  height: 110px;
  margin-bottom: 30px;
}
.footer-atom__links {
  display: flex;
  gap: 15px;
  float: left;
}
.footer-atom__grid__copyright {
  float: right;
  letter-spacing: 1.2px;
  font-size: 12px;
}
.footer-atom__content__links a {
  color: white;
  font-family: 'bred', sans-serif;
  letter-spacing: 1.1px;
  font-size: 12px;
}

.footer-atom__content__links a:active {
  color: #2637f3;
}
.footer-atom__content__links a:hover {
  color: #2637f3;
}
@media all and (min-width: 1024px) {
  .footer-atom__content {
    padding: 40px;
    padding-bottom: 20px;
  }
  .footer-atom__content__right {
    display: row;
  }
  .footer-atom__content__links {
    display: flex;
    justify-content: left;
  }
  .footer-atom__links {
    width: 300px;
  }
  .footer-atom__content__links a {
    margin-top: 10px;
  }
  .footer-atom__grid__copyright {
    margin-top: -16px;
  }

  .footer-atom__content {
    justify-content: center;
  }
}

@media all and (max-width: 1025px) {
  .footer-atom {
    padding-bottom: 20px;
  }
}
</style>
